/* eslint-disable */
import { Button } from 'antd';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HomeOutlined } from '@ant-design/icons';
import { Typography } from '@mui/material';
import { fetchWalletBalanceAsync } from 'redux/WalletSlice';
import { useDispatch } from 'react-redux';
import { handleCatchError } from 'utils/CatchHandler';
import GlobalBackButton from 'views/utilities/BackButtonGlobal';
import BcConvertModal from 'views/Components/BcConvertModal';
import Spinner from 'views/Components/LoadingSinner';
import CommonTable from 'views/Components/CommonTable';
import { checkMerchantOrBCAPI, checkPermissionGet } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import withAccessControlResetPassword from 'utils/HOC/resetPasswordHOC';
import ReKYCDialog from 'views/Components/Dialogs/ReKycDialog';
import BioAuthExistingUsers from './DmtAuthComponents/BioAuthExistingUsers';
import EditOptionComponent from '../EditOptionComponent';
import { fetchCustomerList, getCustomerByVendor } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';
const commonStyles = {
    m: 0
};

const DenseTable = () => {
    const uid = localStorage.getItem('id');
    const dmtType = 1;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMsg, setErrorMsg] = useState('');
    const [customers, setCustomers] = useState([]);
    const [search, setSearch] = useState('');
    const [isLoadingTable, setIsLoadingTable] = useState(false);
    const [merchantModalOpen, setMerchantModalOpen] = useState(false);
    const [isBcConvertPending, setIsBcConvertPending] = useState(false);
    const [isCheckLoading, setIsCheckLoading] = useState(true);
    const [checkExistLoading, setCheckExistLoading] = useState(false);
    const [reKycDetails, setReKycDetails] = useState({ shouldOpen: false });
    const [showAuth, setShowAuth] = useState(false);
    const [dataForEkyc, setDataForEkyc] = useState([]);
    const [filtere, setFiltered] = useState();
    const [Index, setIndex] = useState();
    const [custId, setCustId] = useState('');
    const [showEditModal, setShowEditModal] = useState(false);
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');

    const filteredData = customers?.filter((item) => item?.mobileNumber?.includes(search));

    const location = useLocation();
    const data = location?.state?.createSuccessData;
    const [page, setPage] = useState(1);
    const [limit] = useState(10);

    const [totalCount, setTotalCount] = useState(0);
    const paginatedData = filteredData;

    const handleBcModalClose = () => {
        setMerchantModalOpen(false);
    };
    const handleCreateClick = () => {
        if (search?.length === 10 && filteredData[0]?.mobileNumber !== search) {
            checkCustomerExist();
        } else if (filteredData[0]?.mobileNumber === search) {
            validateMobile();
            globalNotifyError('Customer Already Exists!');
        } else {
            validateMobile();
        }
    };

    const handleTransferClick = (data, index) => {
        const filteredData = customers;
        localStorage.setItem('sendernumber', data?.mobileNumber);

        if (data?.ekycStatus === true) {
            navigate('/moneyTransfer1/moneyTransfer', { state: { data, filteredData, index } });
        } else {
            setShowAuth(true);
        }
    };
    const verifyRekycStatus = async () => {
        const permissionResponse = await checkPermissionGet();
        if (permissionResponse?.status === 200) {
            const isWhitelabel = permissionResponse?.data.whitelabel;
            if (!isWhitelabel) {
                setReKycDetails({ shouldOpen: true });
            } else {
                setReKycDetails({ shouldOpen: false });
            }
        }
    };
    //API call functions
    const customerDetails = async () => {
        try {
            //CHECKING FOR  MERCHANT OR BC
            if (!search) {
                setIsCheckLoading(true);
            }
            const agentid = localStorage.getItem('id');
            const payloadCheck = { agentid };
            const merchantBcCheckResponse = await checkMerchantOrBCAPI(payloadCheck);
            setIsCheckLoading(false);
            const agentType = merchantBcCheckResponse?.data?.agentType;
            const pendingStatus = merchantBcCheckResponse?.data?.isPending;
            setIsBcConvertPending(pendingStatus);

            if (agentType === 'Merchant' || pendingStatus || shouldshowEsign === 'true') {
                setMerchantModalOpen(true);

                return;
            }
            //CHECKING ENDS HERE
            if (!search) {
                setIsLoadingTable(true);
            }
            const response = await fetchCustomerList('fino', page, limit, '2', search);

            if (response?.data?.success) {
                const customerList = response?.data?.data?.result;

                setCustomers(Array.isArray(customerList) ? customerList : []);
                setTotalCount(response?.data?.data?.pagination?.totalCount || 0);
                setIsLoadingTable(false);
                setIsLoadingTable(false);
            }
            // else {
            // navigate('/unauthorized-section', { state: response?.data?.message });
            // }
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };
    // const handleSearch = (e) => {
    //     let value = e.target.value.replace(/[^\d]/g, '');

    //     if (value.length > 0 && !['6', '7', '8', '9'].includes(value[0])) {
    //         value = '';
    //     }

    //     value = value.slice(0, 10); // Mobile number is max 10 digits
    //     setSearch(value);

    //     if (value.length === 10 || value.length === 0) {
    //         setPage(1); // Optional: reset to first page
    //         customerDetails();
    //     }
    // };
    const handleChange = (e) => {
        const input = e.target.value.replace(/\D/g, ''); // Ensure only digits are entered
        if (input.length <= 10) {
            setSearch(input);
            setPage(1); // Reset to page 1 on search change
        }
    };

    useEffect(() => {
        if (search.length === 10 || search.length === 0) {
            customerDetails();
        }
    }, [page, search]);

    //API to check whether the entered phone number is registered under any of the agent of the same distributor
    const checkCustomerExist = async () => {
        try {
            setCheckExistLoading(true);
            const phone = search;
            const agentid = localStorage.getItem('id');
            const payload = { agentId: '2', customerMobileNo: phone, dmtType };
            const response = await getCustomerByVendor(payload);
            setCheckExistLoading(false);
            const innerData = response?.data;
            const { ekycStatus } = innerData?.data || {};
            const info = data?.note;
            const senderno = search;
            if (ekycStatus) {
                navigate('/moneyTransfer1/moneyTransfer', { state: { search, data, senderno } });
            } else if (ekycStatus === false) {
                navigate('/moneyTransfer1/createCustomer', { state: { search, info } });
            }
        } catch (error) {
            setCheckExistLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };
    useEffect(() => {
        dispatch(fetchWalletBalanceAsync());

        verifyRekycStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // console.log('res in state :', responseData);
    const showModal = (newValue) => {
        setShowAuth(true);
        setShowAuth(newValue);
    };
    const showEdit = (newValue) => {
        setShowEditModal(true);
        setShowEditModal(newValue);
    };

    function buttonView(item, index) {
        localStorage.setItem('sendernumber', item?.mobileNumber);
        const filteredDatas = customers;
        setDataForEkyc(item);
        setFiltered(filteredDatas);
        setIndex(index);
        if (item?.ekycStatus === true) {
            navigate('/moneyTransfer1/viewBeneficiary', { state: { item, filteredData, index } });
        } else {
            setShowAuth(true);
        }
    }

    useEffect(() => {
        if (data) {
            globalNotifySuccess('Customer created successfully!');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    const validateMobile = () => {
        const re = /^[0-9]{10}$/; // Regular expression to match 10 digit mobile number
        if (!re.test(search)) {
            setErrorMsg('Please enter a valid 10 digit mobile number');
        } else {
            setErrorMsg('');
        }
    };
    const handleEditClick = (row, index) => {
        setShowEditModal(true);
        setCustId(row?.id);
    };
    const listUpdate = (row, index) => {
        customerDetails();
    };

    const columns = [
        {
            header: 'Sl. No',
            render: (row, index) => (page - 1) * limit + index + 1
        },
        {
            header: 'Customer Name',
            key: 'customerName'
        },
        {
            header: 'Mobile No.',
            key: 'mobileNumber'
        },
        {
            header: 'Edit',
            render: (row, index) => (
                <Button type="primary" variant="contained" size="small" onClick={() => handleEditClick(row, index)}>
                    Edit
                </Button>
            )
        },
        {
            header: 'View',
            render: (row, index) => (
                <Button type="primary" variant="contained" size="small" onClick={() => buttonView(row, index)}>
                    View
                </Button>
            )
        },
        {
            header: 'Transfer',
            render: (row, index) => (
                <Button type="primary" variant="contained" size="small" onClick={() => handleTransferClick(row, index)}>
                    Transfer
                </Button>
            )
        }
    ];

    return (
        <>
            {/* <<<<<<<Breadcrumb starts here>>>>>> */}
            <Box
                sx={{
                    width: '100%',
                    height: 'auto',
                    backgroundColor: '#fff',
                    ...commonStyles,
                    borderRadius: 2,
                    boxShadow: 2,
                    padding: '20px 10px',
                    '@media screen and (min-width: 600px)': {
                        padding: 2
                    }
                }}
            >
                <Typography variant="h3">
                    <GlobalBackButton />
                    Domestic Money Transfer
                </Typography>

                <Box sx={{ marginTop: '10px' }}>
                    <Link to="/merchant-home" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <HomeOutlined />
                    </Link>
                    <Typography component="span" style={{ margin: '0 10px' }}>
                        &gt;
                    </Typography>
                    <Typography component="span">Domestic Money Transfer</Typography>
                </Box>
            </Box>
            {/* <<<<<<<Breadcrumb end here>>>>>>> */}
            <Box
                component="form"
                sx={{
                    '& > :not(style)': { mb: 1, mt: 2, width: '30ch' }
                }}
                noValidate
                autoComplete="off"
            >
                {/* <FormControl> */}
                <Stack direction="row" spacing={1}>
                    <Tooltip title="Please ensure you enter the Aadhaar-linked mobile number here, as the OTP required for verification will be sent to the mobile number associated with the provided Aadhaar number.">
                        <TextField
                            label="Search with Mobile"
                            name="mobile"
                            value={search}
                            onChange={handleChange}
                            variant="outlined"
                            helperText={errorMsg}
                            error={Boolean(errorMsg)}
                            onBlur={validateMobile}
                        />
                    </Tooltip>

                    {/* <Button type="submit" variant="contained">
                            Verify
                        </Button> */}
                    <Box sx={{ '& > :not(style)': {}, paddingTop: 1 }}>
                        <Tooltip title="Click to create new customer">
                            <Button
                                loading={checkExistLoading}
                                onClick={handleCreateClick}
                                shape="circle"
                                type="primary"
                                icon={<AddIcon />}
                            />
                        </Tooltip>
                    </Box>
                </Stack>

                {/* </FormControl> */}
            </Box>
            <CommonTable
                columns={columns}
                data={paginatedData}
                isLoading={isLoadingTable}
                totalCount={totalCount}
                page={page}
                limit={limit}
                onPageChange={(e, value) => setPage(value)}
            />
            <ToastContainer />
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    serviceName={'dmt'}
                    shouldshowEsign={shouldshowEsign}
                />
            )}

            <Spinner loading={isCheckLoading} />
            {reKycDetails.shouldOpen && <ReKYCDialog />}
            {showAuth && <BioAuthExistingUsers showModal={showModal} datas={dataForEkyc} index={Index} filteredData={filtere} />}
            {showEditModal && <EditOptionComponent showEdit={showEdit} custId={custId} listUpdate={listUpdate} />}
        </>
    );
};

export default withAccessControlResetPassword(DenseTable);
